import React, { FC } from 'react';
import { useLocale } from '../../contexts/localeContext';
import { TranslationKeys } from '../../contexts/TranslationKeys';
import { getDayOptions } from '../../models/DayOptions';
import CheckboxListField from '../checkbox-list-field/checkbox-list-field';

export const AccessTimePatternDetails: FC = () => {
    const { translate } = useLocale();

    return <>
        <div className="text-sm max-w-xs">
            <span className='text-xs'>{translate.byKey(TranslationKeys.daysOfTheWeek)}:</span>
            <CheckboxListField
                name="dayList"
                options={getDayOptions(translate)}
                compact={true} />
        </div>
    </>;
};
